// components/NetworkStatusOverlay.jsx
import React from "react";
import { WifiOff } from "lucide-react";

const NetworkStatusOverlay = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-gray-900 rounded-full px-4 py-2 flex items-center gap-2 border border-gray-800 shadow-lg">
        <WifiOff className="w-3.5 h-3.5 text-red-400 animate-pulse" />
        <span className="text-xs text-gray-300">Reconnecting...</span>
      </div>
    </div>
  );
};

export default NetworkStatusOverlay;